import conflict from './conflict'

export default {
  path: 'conflict',
  meta: {
    label: 'dictionaryConflict',
    auth: 'dictionary'
  },
  component: {
    name: 'Dictionary',
    render(c) {
      return c('router-view')
    }
  },
  children: [conflict]
}
